/**
 * 直播相关js，提供功能：开启直播/切换分辨率、退出直播、直播抢占录像、拍照
 */
import { CHAT, websocketapp, ACION_REQUEST, setHandleHelmetOperationResponse } from '@/common/websocket/index'
import { getSession } from '@/api/common'

/**
 * 开启直播 / 切换分辨率
 * @param {String} serialNumber 设备序列号
 * @param {Number} resolution 清晰度，默认0
 */
function sendLiveUrlRequest(serialNumber, resolution = 0) {
  var sendMsg = {
    action: ACION_REQUEST.LIVE,
    content: {
      type: 0,
      resolution,
      // 是否录制
      transcribe: getSession('TRANSCRIBE_LIVE'),
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, serialNumber, sendMsg)
}

/**
 * 定时发送直播状态
 * @param {String} serialNumber 设备序列号
 * @param {Number} resolution 清晰度，默认0
 */
function sendLiveRequestInterval(serialNumber, resolution = 0) {
  var sendMsg = {
    action: ACION_REQUEST.LIVE,
    content: {
      type: 3,
      resolution,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, serialNumber, sendMsg)
}

/**
 * 退出直播
 * @param {String} serialNumber 设备序列号
 * @param {Number} resolution 清晰度，默认720P
 */
function exitLiving(serialNumber) {
  console.log('exitLiving', serialNumber)
  var sendMsg = {
    action: ACION_REQUEST.LIVE,
    content: {
      type: 1,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, serialNumber, sendMsg)
}

/**
 * 直播 抢占 录像
 * @param {String} serialNumber 设备序列号
 * @param {Number} resolution 清晰度，默认720P
 */
function grabRecord(serialNumber) {
  var sendMsg = {
    action: ACION_REQUEST.LIVE,
    content: {
      type: 2,
      // 是否录制
      transcribe: getSession('TRANSCRIBE_LIVE'),
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, serialNumber, sendMsg)
}

export { setHandleHelmetOperationResponse, sendLiveUrlRequest, sendLiveRequestInterval, exitLiving, grabRecord }
